import { Box, List, ListItemButton, ListItemText } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import {
  NavLink as RouterLink,
  matchPath,
  useLocation,
} from 'react-router-dom';

const ListItemStyle = styled(props => (
  <ListItemButton disableGutters {...props} />
))(({ theme }) => ({
  ...theme.typography.body2,
  height: 30,
  position: 'relative',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2.5),
}));

const ListText = styled(ListItemText)`
  font-family: Noto Sans KR;
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
  color: #333;
`;

NavItem.propTypes = {
  item: PropTypes.object,
  active: PropTypes.func,
};

function NavItem({ item, active }) {
  const isActiveRoot = active(item.path) && !item.noHighlight;
  const { title, path, info } = item;

  const activeRootStyle = {
    color: '#5546A9',
    fontWeight: 'fontWeightMedium',
    bgcolor: '#F5F7FE',
    borderRadius: '10px',
    '&:hover': {
      bgcolor: '#F5F7FE',
    },
  };

  return (
    <ListItemStyle
      component={RouterLink}
      to={path}
      sx={{
        ...(isActiveRoot && activeRootStyle),
        p: { xs: '20px', md: 'default' },
        borderRadius: '10px',
      }}
    >
      <ListText
        disableTypography
        primary={title}
        sx={{
          ...(isActiveRoot && activeRootStyle),
        }}
      />
      {info && info}
    </ListItemStyle>
  );
}

NavSection.propTypes = {
  navConfig: PropTypes.array,
};

export default function NavSection({ navConfig, ...other }) {
  const { pathname } = useLocation();
  const match = path =>
    path ? !!matchPath({ path, end: false }, pathname) : false;

  return (
    <Box
      {...other}
      sx={{ pl: { xs: 0, md: 2 }, height: { xs: '100%', md: 'defaults' } }}
    >
      <List
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: '16px', md: 'default' },
        }}
      >
        {navConfig.map(item => (
          <NavItem key={item.title} item={item} active={match} />
        ))}
      </List>
    </Box>
  );
}
